const TERMS_INFO = 'index/TERMS_INFO' as const;
const SET_TERMS_INFO = 'index/SET_TERMS_INFO' as const;

// 이 리덕스 모듈에서 관리 할 상태의 타입을 선언합니다
export type TermsState = {
  mandatory?: boolean;
  optional: boolean;
};

export const getTermsInfo = () => ({
  type: TERMS_INFO,
});

export const setTermsInfo = (state: TermsState) => ({
  type: SET_TERMS_INFO,
  payload: state,
});

type TermsAction = ReturnType<typeof getTermsInfo> | ReturnType<typeof setTermsInfo>;

// 초기상태를 선언합니다.
const initialState: TermsState = {
  mandatory: true,
  optional: false,
};

// 리듀서를 작성합니다.
// 리듀서에서는 state 와 함수의 반환값이 일치하도록 작성하세요.
// 액션에서는 우리가 방금 만든 CounterAction 을 타입으로 설정합니다.
function terms(state: TermsState = initialState, action: TermsAction): TermsState {
  switch (action.type) {
    case TERMS_INFO:
      return { ...state };
    case SET_TERMS_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default terms;
